import { render } from "./formbasic-input.vue?vue&type=template&id=3baeb671"
import script from "./formbasic-input.vue?vue&type=script&lang=js"
export * from "./formbasic-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__